<template lang="pug">
  div.sources-waste.source-update
    e-form-modal(
    ref="modalForm"
    @submitModalForm="sendForm()"
    :hideDeleteButton="false"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title
          template(v-if="fields && fields.id") {{fields.fact_address}}
          template(v-else) Добавление новой записи
        div.tabs
          span(@click="tabView = 'tab1'" :class="activeClass('tab1')") Общие сведения
          span(@click="tabView = 'garbages'" :class="activeClass('garbages')") Отходообразователи
          span(@click="tabView = 'msns'" :class="activeClass('msns')") МСиНы
          span(@click="tabView = 'operators'" :class="activeClass('operators')") Операторы
          span(@click="tabView = 'garbage'" :class="activeClass('garbage')") Отходы
      slot
        e-form(:formValidator="formValidator")
          // вкладка ОБЩИЕ СВЕДЕНИЯ
          div(v-show="tabView == 'tab1'")
            div.body
              div.col
                e-form-subtitle(text="Тип источника отходов")

                e-form-group(
                name="waste_types"
                :model="fields"
                tabView="tab1"
                inputType="checkbox[]"
                :options="wasteTypes"
                )

                e-form-subtitle(text="Сведения об управлении")
                e-form-group(
                name="management_type"
                :model="fields"
                tabView="tab1"
                :options="managementTypes"
                inputType="select"
                label="Тип упарвления"
                )
                e-form-group(
                name="management_name"
                :model="fields"
                tabView="tab1"
                label="Наименование"
                )

                template(
                v-if="showHiddenFields === true"
                )
                  e-form-subtitle(text="Администрирование")

                  e-form-group(
                  name="municipality_name"
                  label="Мун образ (будет перезапис после выбора местополож)"
                  placeholder="Любой текст"
                  :model="fields"
                  tabView="tab1"
                  )
                  e-form-group(
                  name="account_number"
                  label="Номер расчетного счета"
                  placeholder="Любой текст"
                  :model="fields"
                  tabView="tab1"
                  )

              div.col
                e-form-subtitle(text="Сведения о лицевых счетах")
                e-form-group(
                name="count_of_account"
                label="Количество лицевых счетов"
                :model="fields"
                tabView="tab1"
                :disabled="true"
                )
                e-form-group(
                name="count_of_account_individual"
                label="Из них юр. лиц"
                :model="fields"
                tabView="tab1"
                :disabled="true"
                )
                e-form-group(
                name="count_of_legal_entity"
                label="Из них физ. лиц"
                :model="fields"
                tabView="tab1"
                :disabled="true"
                )

                e-form-subtitle(text="Сводка по отходам")

                e-form-group(
                name="garbage_form_norm"
                label="Образование отходов по нормативу (тонн/год)"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                )
                e-form-group(
                name="garbage_form_fact"
                label="Образование отходов по отчетности (тонн/год) "
                :model="fields"
                tabView="tab1"
                validationRule="double"
                )


              div.col
                div.col-block
                  div(
                   style="visibility:hidden;"
                  ).title
                    p
                e-location(
                :formValidator="formValidator"
                :model="fields"
                name="fact_address"
                :addressData="addressData"
                tabView="tab1"
                :required="true"
                @locationChange="onLocationChange"
                )



          div(v-show="tabView == 'garbages'")
            garbages(:id="fields.id")

          div(v-show="tabView == 'msns'")
            msns(
            :fields="fields"
            @saved="msnUpdated"
            @delete="msnUpdated"
            )

          div(v-show="tabView == 'operators'")
            operator-table(:id="fields.id")

          div(v-show="tabView == 'garbage'")
            garbage-table(:id="fields.id")


</template>

<script>
  import {mongoApi} from '../../api/api-endpoints.js'
  import sourceFormMixin from  './mixins/source-form'
  import {SourcesWasteSources} from '../../config/mongo'
  import Garbages from "./components/garbages";
  import Msns from "./components/msns";
  import GarbageTable from "./components/garbage-table";
  import OperatorTable from "./components/operator-table";

  export default {
    components: {OperatorTable, GarbageTable, Msns, Garbages},
    mixins: [sourceFormMixin],
    data () {
      return {
        tabView: 'tab1',
        fields: {}
      }
    },
    methods: {
      getUpdateOrCreateUrl () {
        if (this.$route.params.id) {
          return mongoApi.updateCollectionItem(SourcesWasteSources, this.$route.params.id)
        }
        return mongoApi.createCollectionItem(SourcesWasteSources)
      },
      getItemEndpoint (route) {
        if (!route.params.id) {
          return null
        }
        return mongoApi.getCollectionItem(SourcesWasteSources, route.params.id)
      }
    }
  }
</script>
